import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AgGridColumnCapabilitiesQueryVariables = Types.Exact<{
  gridId: Types.Scalars['String']['input'];
}>;


export type AgGridColumnCapabilitiesQuery = { __typename?: 'Query', agGridColumnCapabilities: { __typename?: 'AgGridColumnCapabilities', gridId: string, sortableColIds: Array<string>, filterableColIds: Array<string> } };


export const AgGridColumnCapabilitiesDocument = new TypedDocumentString(`
    query AgGridColumnCapabilities($gridId: String!) {
  agGridColumnCapabilities(gridId: $gridId) {
    gridId
    sortableColIds
    filterableColIds
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AgGridColumnCapabilities: build.query<AgGridColumnCapabilitiesQuery, AgGridColumnCapabilitiesQueryVariables>({
      query: (variables) => ({ document: AgGridColumnCapabilitiesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAgGridColumnCapabilitiesQuery, useLazyAgGridColumnCapabilitiesQuery } = injectedRtkApi;
